import { type ApiHandlerContract, ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { CustomerGroupBuilderSettingsValidated } from '../types/customer-group.schema';

export interface CustomerGroupSettingsApiContract {
  update(settings: CustomerGroupBuilderSettingsValidated): Promise<void>;
}

export class CustomerGroupSettingsApi
  extends ApiService
  implements CustomerGroupSettingsApiContract
{
  constructor(
    api: ApiHandlerContract,
    private slug: string,
  ) {
    super(api);
  }
  public update(settings: CustomerGroupBuilderSettingsValidated) {
    const body = Object.entries(settings).map(([key, value]) => ({
      key,
      value: value ?? null,
    }));

    return this.api.proxy({
      method: 'PATCH',
      path: '/v1/settings/{slug}',
      params: { slug: this.slug },
      payload: body,
    });
  }
}
